import AllLeadView from './AllLeadView';

export default AllLeadView;



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/container/AllLeadView/index.js